import * as swcHelpers from '@swc/helpers';

const fromListStoreGroupsQueryToStoreGroup = (data)=>{
    if (!data) {
        return {};
    }
    const sortedStores = [
        ...data.multiStoreGroups,
        ...data.singleStoreGroups
    ].sort((a, b)=>a.name.toLowerCase().localeCompare(b.name.toLowerCase())
    );
    const storeGroups = sortedStores.reduce((acc, value)=>{
        var ref;
        const name = (ref = value.name) === null || ref === void 0 ? void 0 : ref.toUpperCase();
        const firstNameStoreLetter = name === null || name === void 0 ? void 0 : name[0];
        if (firstNameStoreLetter) {
            var _firstNameStoreLetter;
            const existingStore = (_firstNameStoreLetter = acc[firstNameStoreLetter]) !== null && _firstNameStoreLetter !== void 0 ? _firstNameStoreLetter : [];
            return swcHelpers.objectSpread({}, acc, {
                [firstNameStoreLetter]: [
                    ...existingStore,
                    value
                ]
            });
        }
        return acc;
    }, {});
    return storeGroups;
};

export { fromListStoreGroupsQueryToStoreGroup };
//# sourceMappingURL=adapters.js.map
